  <div class="datetime-picker">
  <ngb-timepicker *ngIf="!disableTimePickers" [(ngModel)]="timeModel" [size]="'small'" (ngModelChange)="onTimeChange()"></ngb-timepicker>
  <div class="form-group">
    <div class="input-group">
      <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="dateModel" ngbDatepicker #d="ngbDatepicker" (ngModelChange)="onDateChange($event)" [minDate]="minDate | isoToNgbDate">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"><fa-icon [icon]="calIcon"></fa-icon></button>
      </div>
    </div>
  </div>
</div>
